export default "__VITE_ASSET__CoP2PFsb__"